import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SchedulerModule} from "./scheduler/scheduler.module";
import {SchedulerRoutingModule} from "./scheduler/scheduler-routing.module";

const routes: Routes = [
  {
    path: '',
    redirectTo: 'scheduler',
    pathMatch: 'full'
  },
  {
    path: 'scheduler',
    loadChildren: () => SchedulerModule
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    SchedulerModule,
    SchedulerRoutingModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
